import { Component, OnInit, ElementRef, EventEmitter, Output, ChangeDetectionStrategy, ChangeDetectorRef, Input } from '@angular/core';
import { values } from 'lodash';
import { SlColorsService } from 'src/app/services/sl-colors.service';

@Component({
	selector: 'app-result-style-editor',
	templateUrl: './result-style-editor.component.html',
	styleUrls: ['./result-style-editor.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class ResultStyleEditorComponent implements OnInit {

	// private picker;
	public currentColor = '#ff00ff';
	public opacity = 50;
	public glowpacity = 50;
	public fill = true;
	public fillColor = '#99ff99';
	public shadowStyleStatic = '0px 0px 6px 6px ';
	public value = '';
	public shadowStyle = '';
	@Input() public useNaturalOverride = true;
	public useNaturalStyles = false;
	@Output() styleChange$: EventEmitter<any> = new EventEmitter();
	constructor(private domNode: ElementRef, private changes: ChangeDetectorRef) { }

	ngOnInit() {
		this.HandleOpacityChange(this.opacity);
		/*this.picker = new Picker($('.picker', this.domNode.nativeElement)[0]);
		this.picker.setOptions({
			alpha: false,
			editor: true,
			popup: 'bottom',
			color: this.currentColor,
			onChange: (color) => {

			},
			onClose: (color) => {
				let r = (color.rgba[0] as number).toString(16);
				if (r.length === 1) { r = '0' + r; }
				let g = (color.rgba[1] as number).toString(16);
				if (g.length === 1) { g = '0' + g; }
				let b = (color.rgba[2] as number).toString(16);
				if (b.length === 1) { b = '0' + b; }
				this.currentColor = '#' + r + g + b;
				this.HandleOpacityChange(this.opacity);
				this.HandleGlowpacityChange(this.glowpacity);
			}

		});*/
	}
	HandleColorChange() {

    this.HandleOpacityChange(this.opacity);
		this.HandleGlowpacityChange(this.glowpacity);
		this.changes.detectChanges();
	}

	Show(style: any) {
		this.value = style;
		this.HandleValueChange(null, false);
	}

	HandleOpacityChange(opacity: number, notify: boolean = true) {
		opacity = opacity;
		let o: string = Math.round(this.opacity * 255 / 100).toString(16);
		if (o.length === 1) {
			o = '0' + o;
		}

		this.fillColor = this.currentColor + o;

		if (this.fill === false) {
			this.fillColor = this.currentColor + '00';
		}
		if (notify === true) { this.NotifyListeners(); }
		this.changes.detectChanges();
	}
	HandleFillChange(event: any, _notify = true) {
		this.fill = event.value === 'true';
		this.HandleOpacityChange(this.opacity);
		this.changes.detectChanges();

	}
	HandleGlowpacityChange(opacity: number, notify: boolean = true) {
		let glow = Math.round(opacity * 254 / 100).toString(16);
		if (glow.length === 1) { glow = '0' + glow; }
		this.shadowStyle = this.shadowStyleStatic + this.currentColor + glow;
		if (notify === true) { this.NotifyListeners(); }
		this.changes.detectChanges();
	}
	NotifyListeners() {
		let value = this.currentColor;
		value += ';';
		if (this.fill === false) {
			value += '-';
		}
		value += (this.opacity / 100.0).toFixed(2);
		value += ';' + (this.glowpacity / 100.0).toFixed(2);
		if (this.useNaturalStyles) {
			value += ';' + 'inherit';
		}

		this.value = value;

		this.styleChange$.emit({
			color: this.currentColor,
			opacity: this.opacity / 100.0,
			glowpacity: this.glowpacity / 100.0,
			stringValue: value
		});
		this.changes.detectChanges();
	}
	NaturalUpdate() {
		if(this.useNaturalOverride === true) {
			$(this.domNode.nativeElement).toggleClass('going-natural', this.useNaturalStyles);
		}
	}

	HandleNaturalChange(event: any, notify: boolean = true) {
		this.useNaturalStyles = (event.value === 'true');
		const values = this.value.split(';');
		if (values.length < 4) {
			if (this.useNaturalStyles === true) { }
			values.push('inherit');

		} else if (values.length > 3) {
			if (this.useNaturalStyles === false) {
				values.pop();
			}
		}
		this.value = values.join(';');
		this.NaturalUpdate();
		this.changes.detectChanges();

	}
	HandleValueChange(event = null, _notify = true) {
		// tslint:disable-next-line:prefer-const
		let color = '#000000';
		let opacity = '0';
		let glowpacity = '0';
		let natural = 'false';
		const values = (event === null) ? this.value.split(';') : event.target.value.split(';');
		if (values.length === 4) {
			[color, opacity, glowpacity, natural] = values;
			if (natural !== 'inherit') {
				values[3] = 'inherit';
				this.value = values.join(';');
				this.changes.detectChanges();
			}
			event = null;
			natural = 'inherit';
			this.useNaturalStyles = true;
			// do nothing
		} else {
			[color, opacity, glowpacity] = values;
			this.useNaturalStyles = false;
		}


		this.currentColor = color;
		if (opacity.substr(0, 1) === '-') {
			this.fill = false;
			opacity = opacity.substr(1);
		} else {
			this.fill = true;
		}

		this.opacity = parseFloat(opacity) * 100;
		this.HandleOpacityChange(this.opacity, false);
		this.HandleFillChange({ value: (this.fill === true ? 'true' : 'false') }, false);
		this.glowpacity = parseFloat(glowpacity) * 100;
		this.HandleGlowpacityChange(this.glowpacity, false);
		this.value = (event === null) ? this.value : event.target.value;

		this.NaturalUpdate();
		this.styleChange$.emit({
			color: this.currentColor,
			opacity: this.opacity / 100.0,
			glowpacity: this.glowpacity / 100.0,
			natural: (this.useNaturalStyles === true) ? 'true' : 'false',
			stringValue: this.value
		});
		this.changes.detectChanges();
	}

}
